import { useQuery } from 'react-query'
import { Box } from '@mui/material'
import TaxDetails from '../components/TaxDetails'
import HouseholdDetails from '../components/HouseholdDetails'
import { getTaxData } from 'services/api/modules/staff-management/staffManagementDashboard'

const TaxTab = ({ windowCheckEmployeeFile, employeeID }) => {
  const { data: tax } = useQuery(['employeeTaxData', employeeID], async () => {
    window.scrollTo(0, 0)
    const { data } = await getTaxData(employeeID)
    return data
  })

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, py: 2 }}>
      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <TaxDetails
          data={tax}
          employeeID={employeeID}
          windowCheckEmployeeFile={windowCheckEmployeeFile}
        />
      </Box>

      <Box sx={{ border: 1, borderRadius: '4.5px', borderColor: 'gray-line.main' }}>
        <HouseholdDetails
          data={tax}
          employeeID={employeeID}
          windowCheckEmployeeFile={windowCheckEmployeeFile}
        />
      </Box>
    </Box>
  )
}

export default TaxTab
